export const stories = [
    {
      image: require('../assets/images/baptismImg.jpg'),
      category: 'BAPTISM',
      date: 'January 10, 2024',
      title: 'Where did Baptism Come From?'
    },
    {
      image: require('../assets/images/faithImg.jpg'),
      category: 'FAITH',
      date: 'February 15, 2024',
      title: 'Growing Your Faith in Difficult Times'
    },
    {
      image: require('../assets/images/communityImg.jpg'),
      category: 'COMMUNITY',
      date: 'March 5, 2024',
      title: 'Building Strong Church Communities'
    },
    {
      image: require('../assets/images/communityImg.jpg'),
      category: 'WORSHIP',
      date: 'April 20, 2024',
      title: 'The Power of Worship in Our Lives'
    }
  ];